import { UserViewType } from '@model/User';
import { createMemo } from '@packages/react';
import React, { createContext } from 'react';

interface ForceUserViewProps {
    as: UserViewType;
    children: any;
}

export const ForceUserViewContext = createContext<string>('');

export const ForceUserView = createMemo<ForceUserViewProps>(
    (props) => {
        const { as, children } = props;

        return <ForceUserViewContext.Provider value={as}>{children}</ForceUserViewContext.Provider>;
    },
    {
        displayName: 'ForceUserView',
    },
);
